// WHY: "Object.entries(object)" returns "mixed" type instead of polymorphic
// Ctrl + C, Ctrl + V from Platform

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getObjectEntries = (object: any): Array<any> => {
    return Object.entries(object);
};
